import { random } from "./rng";

function randFloat() {
  return random();
}

export default randFloat;
